export default "__VITE_ASSET__2028d894__"